<template>
  <div id="sd-nav">
    <!-- <div class="box-shadow">
      <img src="../../assets/img/common-img/jianbian-xia@2x.png" alt="" class="shadow-img">
    </div>-->
    <ul class="nav-wrapper">
      <li
        class="nav-item"
        @click="goRouter('SdSeeDoctor')"
        :class="{activeNav:router==='/SdSeeDoctor'}"
      >
        <img :src="seeIcon" alt="" class="nav-icon">
        <span class="nav-name">视频</span>
      </li>
      <li
        class="nav-item"
        @click="goRouter('SdAskDoctor')"
        :class="{activeNav:router==='/SdAskDoctor'}"
        v-if="!inMiniProgram"
      >
        <img :src="askIcon" alt="" class="nav-icon">
        <span class="nav-name">问诊</span>
      </li>
      <li
        class="nav-item"
        @click="goRouter('/goRegist')"
        :class="{activeNav:router==='/goRegist'}"
        v-if="!inMiniProgram"
      >
        <img :src="registration" alt="" class="nav-icon">
        <span class="nav-name">挂号</span>
      </li>
      <li
        class="nav-item nav-item-mine"
        @click="goRouter('SdUserInfo')"
        :class="{activeNav:router==='/SdUserInfo'}"
      >
        <img :src="myIcon" alt="" class="nav-icon">
        <span class="nav-name">我的</span>
        <div class="number-box" v-if="totalNum>0">
          <span class="box-wrapper"></span>
        </div>
      </li>
      <!-- <li class="nav-item" @click="goRouter('/joinUs')" :class="{activeNav:router==='/joinUs'}">
        <img :src="cooperation" alt="" class="nav-icon">
        <span class="nav-name">合作</span>
      </li>-->
    </ul>
  </div>
</template>

<script>
  import api from "@/api/index";
  import iMp from "@/common/isMp";
  export default {
    data() {
      return {
        seeIcon: "",
        askIcon: "",
        myIcon: "",
        cooperation: "",
        registration: "",
        activeNav: false,
        router: "",
        totalNum: null
      };
    },
    mixins: [iMp],
    beforeMount() {
      this.currentImg();
      if (localStorage.getItem("token")) {
        this.getTotal();
      }
    },
    mounted() {},
    activated() {},
    methods: {
      goRouter(nav) {
        this.$router.push(nav);
      },
      currentImg() {
        this.router = this.$route.path;
        this.seeIcon =
          this.router === "/SdSeeDoctor"
            ? require("../../assets/img/nav-img/看病-pressed@2x.png")
            : require("../../assets/img/nav-img/看病-normal@2x.png");
        this.askIcon =
          this.router === "/SdAskDoctor"
            ? require("../../assets/img/nav-img/问诊-pressed@2x.png")
            : require("../../assets/img/nav-img/问诊-normal@2x.png");
        this.myIcon =
          this.router === "/SdUserInfo"
            ? require("../../assets/img/nav-img/我的-pressed@2x.png")
            : require("../../assets/img/nav-img/我的-normal@2x.png");
        this.cooperation =
          this.router === "/joinUs"
            ? require("../../assets/img/cooperation/cooperation-active.png")
            : require("../../assets/img/cooperation/cooperation.png");
        this.registration =
          this.router === "/goRegist"
            ? require("../../assets/img/nav-img/guahao perss.png")
            : require("../../assets/img/nav-img/guahao nomarl.png");
      },
      getTotal() {
        let url = api.wdxx;
        this.$http
          .get(url, {
            headers: {
              "x-token": localStorage.getItem("token")
            }
          })
          .then(res => {
            if (res.data.code == 0) {
              this.totalNum = res.data.data;
            }
          });
      }
    }
  };
</script>

<style lang="postcss">
  #sd-nav {
    z-index: 999;
    background-color: #fffffd;
    position: fixed;
    bottom: 0;
    height: 98px;
    display: flex;
    width: 100%;
    align-items: center;
    box-sizing: border-box;
    & .nav-wrapper {
      width: 100%;
      display: flex;
      justify-content: space-around;
      box-shadow: 1px 8px 60px rgba(0, 0, 0, 0.1);
      align-items: center;
      & .nav-item {
        display: flex;
        padding-bottom: 10px;
        flex-direction: column;
        font-size: 20px;
        color: #999999;
        align-items: center;
        justify-content: center;
        & .nav-icon {
          width: 58px;
          margin: 10px 0 3px 0;
        }
        &.nav-item-mine {
          position: relative;
          & .number-box {
            position: absolute;
            background-color: #f43531;
            border: 10px solid #f43531;
            border-radius: 50%;
            height: 1px;
            width: 1px;
            color: white;
            font-size: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
            bottom: 61px;
            right: 0px;
          }
        }
      }
    }
    & .activeNav {
      & .nav-name {
        color: #37bd19;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shenduNav/SdNav.vue